<template>
	<div class="checkout wrapper murk">
		<!-- empty page that verify token only spinner show in the page -->
	</div>
</template>

<script>
import store from '../store';

export default {
	name: 'Checkout',
	metaInfo() {
		return {
			titleTemplate: `%s | ${this.$t('checkout.title')}`,
		};
	},
	data() {
		return {};
	},

	beforeRouteEnter(to, from, next) {
		const locale = to.params.locale;

		store.commit('setToken', to.query.token);

		if (to.query.method && (to.query.method === 'epin' || to.query.method === 'nexoncards')) {
			// handling epin and nexon game cards selected on the payment revamp add balance
			store.dispatch('fetchVerifyEpinNexonCardsToken', to.params).then((response) => {
				console.log(response);
				next({
					name: 'redeem-balance',
					replace: true,
					params: {
						locale,
					},
				});
			});
		} else if (store.state.appType === 'steam') {
			// nx purchase with steam wallet for ms/mb/vindictus (comming from  the /wallet/en/steam-add-balance)
			if (to.query.gamecode) store.commit('setGameCode', to.query.gamecode);

			store.dispatch('fetchVerifySteamToken').catch((error) => {
				let errorCode;
				if (error && error.response && error.response.data && error.response.data.code) {
					errorCode = error.response.data.code;
				}
				next({
					name: 'steam-result',
					replace: true,
					params: {
						locale,
					},
					query: {
						...(errorCode && { error_code: errorCode }),
						...(to.query.gamecode && { gamecode: to.query.gamecode }),
					},
				});
			});
		} else {
			store.dispatch('fetchBillingInfoVerifyToken', to.params).then(() => {
				next({
					name: 'purchase',
					replace: true,
					params: to.params,
				});
			});
		}
	},
};
</script>
